import React, { createContext } from "react";

import "./Products.css";

function Products() {
  return (
    <div className="products">
      <div class="product-categories-grid">
        <div class="product-category-grid-item-1">Все</div>
        <div class="product-category-grid-item-2">FDM-принтеры</div>
        <div class="product-category-grid-item-3">SLM-принтеры</div>
        <div class="product-category-grid-item-4">Лабораторное оборудование</div>
        <div class="product-category-grid-item-5">Производственное оборудование</div>
      </div>
      <div className="category-boards">
        <div className="category-board">
          1
        </div>
        <div className="category-board">
          2
        </div>
      </div>
    </div>
  );
}

export default Products;
